import { ClinicalIconProps } from "@jasper/forms";
import { Card, Text, ThemeIcon, Title } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { ComponentType } from "react";

type ProductCategoryCardProps = {
  icon: ComponentType<ClinicalIconProps>;
  label: string;
  description: string;
  isSelected: boolean;
  quantity: number;
  onClick: () => void;
};

export const ProductCategoryCard = (props: ProductCategoryCardProps) => {
  const Icon = props.icon;
  const { hovered, ref } = useHover<HTMLButtonElement>();

  return (
    <Card
      component="button"
      type="button"
      ref={ref}
      withBorder
      onClick={props.onClick}
      w="100%"
      h="100%"
      style={{
        cursor: "pointer",
        textAlign: "left",
        borderColor: hovered
          ? "var(--mantine-color-brand-3)"
          : "var(--mantine-color-ink-1)",
      }}
    >
      <ThemeIcon w={54} h={54} bg="brand.0" c="brand.6" mb="s3">
        <Icon size={30} />
      </ThemeIcon>
      <Title variant="display" size={17} c="ink.9" mb="s1">
        {props.label}
      </Title>
      <Text size="sm" c="ink.9">
        {props.description}
      </Text>
      <Text variant="eyebrow" c="ink.4" mt="s3">
        {props.quantity} produit{props.quantity > 1 ? "s" : ""}
      </Text>
    </Card>
  );
};
